export default __webpack_public_path__ + "static/media/menu_filled.5c0be047.svg";